// types
import { InputType, InputProps, InputSize } from './types';

// components
import Input from './input';

export default function InputText({
  title,
  onChange,
  name,
  className,
  size = InputSize.MEDIUM,
  disabled,
  placeholder,
  value,
  maxLength,
  error,
  prefix,
  suffix,
  labelClassName = '',
  onBlur,
  onKeyUp,
  onFocus,
  tabIndex,
  inputRef,
  amountInput,
  currency,
}: InputProps): React.JSX.Element {
  return (
    <Input
      title={title}
      onChange={onChange}
      name={name}
      size={size}
      className={className}
      disabled={disabled}
      placeholder={placeholder}
      onBlur={onBlur}
      onKeyUp={onKeyUp}
      value={value}
      type={InputType.TIME}
      maxLength={maxLength}
      labelClassName={labelClassName}
      error={error}
      prefix={prefix}
      onFocus={onFocus}
      tabIndex={tabIndex}
      suffix={suffix}
      inputRef={inputRef}
      amountInput={amountInput}
      currency={currency}
    />
  );
}
